exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes ftv-magneto-panel-live-option-show {\n  0% {\n    transform: translateX(100%);\n  }\n\n  100% {\n    transform: translateX(0%);\n  }\n}\n\n@keyframes ftv-magneto-panel-live-option-hide {\n  0% {\n    transform: translateX(0%);\n  }\n\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n@keyframes ftv-magneto-panel-live-option-show-portrait {\n  0% {\n    transform: translateY(100%);\n  }\n\n  100% {\n    transform: translateY(0%);\n  }\n}\n\n@keyframes ftv-magneto-panel-live-option-hide-portrait {\n  0% {\n    transform: translateY(0%);\n  }\n\n  100% {\n    transform: translateY(100%);\n  }\n}\n", ""]);

// exports
